import {
  LANGUAGE_AUTO_DETECT,
  LANGUAGE_STRING_TO_CODE,
  WHISPER_LANGUAGE_NAMES,
} from "@pages:app/audio/const";
import { TFunction } from "i18next";

/*
 * Auto-detect first, then every language whisper can transcribe.
 * The display names live in the `audio.languages.*` translations.
 */
export const LANGUAGE_CODES = [
  LANGUAGE_AUTO_DETECT,
  ...Object.keys(WHISPER_LANGUAGE_NAMES),
];

/*
 * The localized name of a language code, or of a language the backend reports by
 * name ("French"); nothing for auto-detect. An unknown value is returned as is.
 */
export const languageLabel = (
  value: string | undefined,
  t: TFunction,
): string | undefined => {
  if (!value || value === LANGUAGE_AUTO_DETECT) return undefined;
  const code = LANGUAGE_STRING_TO_CODE[value.toLowerCase()] ?? value;
  return t(`audio.languages.${code}`, { defaultValue: value });
};
